import React from 'react';
import {OrderSummary} from "../types/dto"; // Corregido: Importa el tipo OrderSummary
import CardHeader from "@mui/material/CardHeader";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import {DataWithLabel} from "../../../components/data/DataWithLabel";
import {OrderSummaryFields} from "../types/fields"; // Corregido: Importa los campos de OrderSummary

interface OrderSummaryCardProps {
    summary: OrderSummary
}

function OrderSummaryCard({summary}: OrderSummaryCardProps) {
    return (
        <Card sx={{p: 0}}>
            <CardHeader title={'Resumen'} sx={{py: 0}}/>
            <CardContent sx={{py: 0, '&:last-child': {pb: 1}}}>
                <Grid container spacing={2}>
                    <Grid item md={1.5} xs={12}>
                        <DataWithLabel label={'Pendientes'} data={summary[OrderSummaryFields.PendingQuantity]}/>
                    </Grid>
                    <Grid item md={1.5} xs={12}>
                        <DataWithLabel label={'Demorados'}
                                       dataProps={{sx: {color: 'red'}}}
                                       data={summary[OrderSummaryFields.DelayedQuantity]}/>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <DataWithLabel label={'Entregas este mes'}
                                       data={summary[OrderSummaryFields.DeliveredCurrentMonth]}/>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <DataWithLabel label={'Entregas mes pasado'}
                                       data={summary[OrderSummaryFields.DeliveredPreviousMonth]}/>
                    </Grid>
                    <Grid item md={3} xs={12}>
                        <DataWithLabel label={'Cantidad sin facturar'}
                                       dataProps={{sx: {color: 'red'}}}
                                       data={summary[OrderSummaryFields.UnbilledQuantity]}
                        />
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default OrderSummaryCard;
